/* eslint-disable max-len */
import STRIcon from '../../../../../assets/environmental.png';
import METIcon from '../../../../../assets/general.png';
import GOVIcon from '../../../../../assets/governance.png';
import RISKIcon from '../../../../../assets/social.png';
import {pillers} from '../../../../../components/Forms/Constants/TCFD/RealEstate/RealEstateQuestions';
import {getTcfdUrl} from '../utils/utils';

import {
  RealEstateGovernanceTabQuestions,
  RealEstateMetricsTargetsTabQuestions,
  RealEstateRiskManagementTabQuestions,
  RealEstateStrategyTabQuestions
} from './realEstateTabs';

export const realEstateGovernance = {
  pillarId: pillers.realEstateGovernance,
  header: {
    imageUrl: GOVIcon,
    title: 'Governance',
    description: `Clarifies board- and management-level accountability for 
climate matters, the foundation for all further action.`,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getTcfdUrl(pillers.realEstateGovernance, '2'),
  tabs: [
    {
      id: 'tab_governance',
      title: 'Governance',
      questions: RealEstateGovernanceTabQuestions
    }
  ]
};

export const realEstateStrategy = {
  pillarId: pillers.realEstateStrategy,
  header: {
    imageUrl: STRIcon,
    title: 'Strategy',
    description:
      'Tests business resilience under plausible climate scenarios to inform long-term planning.',
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getTcfdUrl(pillers.realEstateStrategy,'2' ),
  tabs: [
    {
      id: 'tab_strategy',
      title: 'Strategy',
      questions: RealEstateStrategyTabQuestions
    }
  ]
};

export const realEstateRiskManagement = {
  pillarId: pillers.realEstateRiskManagement,
  header: {
    imageUrl: RISKIcon,
    title: 'Risk Management',
    description:
      'Integrates climate-related risks and opportunities into the enterprise risk framework to prevent surprises.',
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getTcfdUrl(pillers.realEstateRiskManagement,'2'),
  tabs: [
    {
      id: 'tab_risk_management',
      title: 'Risk Management',
      questions: RealEstateRiskManagementTabQuestions
    }
  ]
};

export const realEstateMetricsTargets = {
  pillarId: pillers.realEstateMetricsTargets,
  header: {
    imageUrl: METIcon,
    title: 'Metrics & Targets',
    description:
      'Establishes quantifiable indicators and deadlines to track and demonstrate progress with credibility.',
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getTcfdUrl(pillers.realEstateMetricsTargets,'2'),
  tabs: [
    {
      id: 'tab_metrics_targets',
      title: 'Metrics & Targets',
      questions: RealEstateMetricsTargetsTabQuestions
    }
  ]
};
